import wx from 'weixin-js-sdk'
import { config } from '../../api'

function wxConfig(data) {
    wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature,// 必填，签名
        jsApiList: ["updateAppMessageShareData","updateTimelineShareData", "openLocation"] // 必填，需要使用的JS接口列表
    });
    wx.ready(() => {
        // var obj = {
        //     title: 'WANS｜品牌互动营销案例精选', // 分享标题
        //     desc: '历史不可复制，只有破局、定局者得以生存', // 分享描述
        //     link: 'https://case.chinawans.com/#/loading', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        //     imgUrl: 'http://case.chinawans.com/img/share.jpg', // 分享图标
        //     success: function () {
        //     // 设置成功
        //     }
        // }
        // // wx.hideOptionMenu();
        // wx.updateAppMessageShareData(obj)
        // wx.updateTimelineShareData(obj)
    })
    wx.error(function (res) {
        console.log(res);
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    });
}
export default {
    install(Vue) {
        Vue.prototype.$wxConfig = function () {
            config({
                url: location.href.split('#')[0]
            }).then(res => {
                var data = res.data.data
                wxConfig(data)
            })
        }
    }
}